import React from "react";
import Grid from "@mui/material/Grid";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import {Control} from "react-hook-form/dist/types/form";
import {Controller} from "react-hook-form";
import {IStatement} from "../../../../queries/pharmacy/pharmacyModel";
import {red} from "@mui/material/colors";

interface ReviewFollowingStatementsProps {
  control: Control<any>;
  statements: IStatement[];
  requiredItems: any;
}

const ReviewFollowingStatements:React.FunctionComponent<ReviewFollowingStatementsProps> = ({
  control,
  statements,
  requiredItems
}) => {
  const filteredStatements = [...statements].sort((a, b) => a.id - b.id).map((statement: IStatement) => {
    return {
      ...statement,
      defaultAnswer: statement?.defaultAnswer ? 'YES' : 'NO'
    }
  });

  return (
    <Grid container spacing={2}>
      {filteredStatements.map((statement: any)=> {
        return (
          <React.Fragment key={statement.id}>
            <Grid item xs={12} sm={6} md={9}>
              <FormLabel
                id={`statement-${statement.id}-label`}
                sx={{color: Object.keys(requiredItems).length > 0 && requiredItems[`statement-${statement.id}`] === undefined ? red[500] : 'inherit'}}
              >
                <div dangerouslySetInnerHTML={{ __html: statement?.question }}></div>
              </FormLabel>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Controller
                name={`statement-${statement.id}`}
                control={control}
                render={({ field }) => (
                  <RadioGroup {...field} aria-labelledby={`statement-${statement.id}-label`} row id={`statement-${statement.id}`} >
                    <FormControlLabel value="YES" control={<Radio />} label="Yes" />
                    <FormControlLabel value="NO" control={<Radio />} label="No" />
                  </RadioGroup>
                )}
              />
            </Grid>
          </React.Fragment>
        )
      })}
    </Grid>
  )
}

export default ReviewFollowingStatements;